import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import RepairVendorConversationRedirect from "./RepairVendorConversationRedirect";

/**
 * Old email links used /repairs/:ticketId?vendorId=… for vendor chat.
 * Landlords are sent to Contractor Bids; vendors keep the redirect flow.
 */
const LegacyRepairTicketRoute = () => {
  const { ticketId } = useParams();
  const [searchParams] = useSearchParams();
  const vendorId = searchParams.get("vendorId");

  if (ticketId && vendorId) {
    return (
      <RepairVendorConversationRedirect
        ticketId={ticketId}
        vendorId={vendorId}
      />
    );
  }

  return <Navigate to="/bids" replace />;
};

export default LegacyRepairTicketRoute;
